import React, { useState } from "react";
import { Avatar } from "antd";

import IconCounts from "../mini/IconCounts";
import CommentBox from "../mini/CommentBox";
import {
  getCommentsFunction,
  likeComment,
  unlikeComment,
} from "../../redux/actions/comAction";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useAuthStore } from "../../store/AuthStore";
dayjs.extend(relativeTime);

const Comment = (props) => {
  const { isLoggedIn } = useAuthStore();

  const [showComment, setShowComment] = useState(false);
  const [reply, setReply] = useState([]);
  const [replies, setReplies] = useState(0);

  const callChild = async () => {
    const repCount = replies;
    const data = await getCommentsFunction(
      repCount + 2,
      1,
      props.comment?.blogPostId,
      props.comment?.id
    );
    setReply(data.comments);
    setReplies(repCount + 2);
  };

  return (
    <div className={props.reply ? "reply-container" : "comment-container"}>
      <div className="the-comment">
        {props.reply ? (
          <div className="flex mb-3 items-center">
            <Avatar
              size={30}
              icon={props.comment?.commenter?.firstName[0]}
              src={props.comment?.commenter?.profileImage}
            />
            <p className="replier">
              {props.comment?.commenter?.role !== "user" && "Dr."}{" "}
              {props.comment?.commenter?.firstName}{" "}
              {props.comment?.commenter?.lastName} ➤ {props.parentCommentor}
            </p>
          </div>
        ) : (
          <div className="flex mb-3 items-center">
            <Avatar
              size={50}
              icon={props.comment?.commenter?.firstName[0]}
              src={props.comment?.commenter?.profileImage}
            />
            <p className="commentor">
              {props.comment?.commenter?.role !== "user" && "Dr."}{" "}
              {props.comment?.commenter?.firstName}{" "}
              {props.comment?.commenter?.lastName}
            </p>
          </div>
        )}

        <p className="ago"> {dayjs(props.comment?.createdAt).fromNow()} </p>
        <p className="com-content">{props.comment?.comment}</p>
        <div className="flex justify-between mb-4">
          <div className="flex gap-3">
            <IconCounts
              disabled={!isLoggedIn}
              onClick={() => {
                if (!isLoggedIn) return;
                props.comment?.isLiked
                  ? unlikeComment(props.comment?.id).then(() =>
                      props.callSelf()
                    )
                  : likeComment(props.comment?.id).then(() => props.callSelf());
              }}
              type={
                "like" +
                (props.comment?.isLiked ? (isLoggedIn ? " filled" : "") : "")
              }
              count={props.comment?.likeCount}
              text="Like"
            />
            <IconCounts
              disabled={!isLoggedIn}
              onClick={() => {
                if (!isLoggedIn) return;
                setShowComment(true);
              }}
              type="comment"
              text="Reply"
              count={props.comment?.replyCount}
            />
          </div>
          {/* <IconCounts
            disabled={!isLoggedIn}
            onClick={() => {
              if (!isLoggedIn) return;
              props.comment?.isFlagged
                ? unflagComment(props.comment?.id).then(() => props.callSelf())
                : flagComment(props.comment?.id).then(() => props.callSelf());
            }}
            type={"flag" + (props.comment?.isFlagged ? " filled" : "")}
            text="Flag"
          /> */}
        </div>
        {showComment && (
          <CommentBox
            callChild={callChild}
            postId={props.comment?.blogPostId}
            parentId={props.comment?.id}
          />
        )}
      </div>
      <div className="my-2">
        {reply?.map((com, index) => (
          <div key={com.id} className={index === 0 ? "ml-4 my-0" : "my-0"}>
            <Comment
              callSelf={callChild}
              reply={true}
              comment={com}
              parentCommentor={
                "Dr." +
                props.comment?.commenter?.firstName +
                " " +
                (props.comment?.commenter?.lastName
                  ? props.comment?.commenter?.lastName
                  : "")
              }
            />
          </div>
        ))}
        {props.comment?.replyCount > reply.length && (
          <p onClick={callChild} className="show-replies">
            Show {reply.length > 0 && "More"} Replies
          </p>
        )}
      </div>
    </div>
  );
};

export default Comment;
